import type { SVGProps } from "react";

export function Rocket(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14 2c4 1 7 4 8 8l-6 6-8-8 6-6z" />
      <path d="M7 11l-4 4 4 1 1 4 4-4" />
      <circle cx="15" cy="9" r="2" />
    </svg>
  );
}
